// Kartenstile. basemap.de (Bundesamt für Kartographie und Geodäsie) zeigt kaum POIs wie
// Restaurants oder Geschäfte und deckt Deutschland ab; POIs lassen sich gezielt einblenden.

const YEAR = new Date().getFullYear();
const OSM = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>';
// Hydranten und POIs stammen immer aus OpenStreetMap, auch auf basemap.de
const BKG = `&copy; GeoBasis-DE / <a href="https://www.bkg.bund.de">BKG</a> (${YEAR}) `
  + '<a href="https://creativecommons.org/licenses/by/4.0/">CC BY 4.0</a> | Daten ' + OSM;

const basemapDe = (variant) =>
  `https://sgx.geodatenzentrum.de/wmts_basemapde/tile/1.0.0/de_basemapde_web_raster_${variant}/default/GLOBAL_WEBMERCATOR/{z}/{y}/{x}.png`;

export const BASE_MAPS = {
  'basemap-farbe': {
    label: 'basemap.de (ohne POIs)',
    url: basemapDe('farbe'),
    attribution: BKG,
    maxNativeZoom: 18,
  },
  'basemap-grau': {
    label: 'basemap.de grau (für Lagekarten)',
    url: basemapDe('grau'),
    attribution: BKG,
    maxNativeZoom: 18,
  },
  osm: {
    label: 'OpenStreetMap (mit POIs)',
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution: OSM,
    maxNativeZoom: 19,
  },
};

export const DEFAULT_BASE_MAP = 'basemap-farbe';
